import { useState, useCallback } from 'react';
import { api } from 'app/api/client';
import { IPathwayDocumentDownloadResponse } from '../types/Documents';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { TRootStackParamList } from 'app/types/navigation';
import { ToastNotifications } from 'app/services/inAppToastNotifications';
import { dynamicTranslations } from '@shared/utils/dynamicTranslation';

type NavigationProp = NativeStackNavigationProp<TRootStackParamList>;

export const useDocumentDownload = (pathwayId: string) => {
  const navigation = useNavigation<NavigationProp>();
  const { t } = dynamicTranslations();
  const [downloadingId, setDownloadingId] = useState<string | null>(null);

  const openDocument = useCallback(async (documentId: string, fileName: string, fileType: string) => {
    try {
      setDownloadingId(documentId);

      const data = await api.get<IPathwayDocumentDownloadResponse>(
        `rpm/api/v1/pathways/${pathwayId}/documents/${documentId}/download`,
      );

      navigation.navigate('DocumentViewerPage', {
        fileUrl: data.url,
        fileType,
        fileName,
      });
    } catch {
      ToastNotifications.displayErrorNotification(
        t('history.documents.patientSection.toast.openError'),
      );
    } finally {
      setDownloadingId(null);
    }
  }, [navigation, pathwayId, t]);

  return { openDocument, downloadingId };
};
